<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type { HeaderBanner } from './HeaderBannerBaseCard.vue'
import HeaderBannerClippedCard from './HeaderBannerClippedCard.vue'
import HeaderBannerImageCard from './HeaderBannerImageCard.vue'
import HeaderBannerUnclippedCard from './HeaderBannerUnclippedCard.vue'

/**
 * HeaderBannerCard
 */
export default defineComponent({
  components: {
    HeaderBannerUnclippedCard,
    HeaderBannerImageCard,
    HeaderBannerClippedCard,
  },
  props: {
    banner: {
      type: Object as PropType<HeaderBanner>,
      required: true,
    },
  },
  computed: {
    headerBannerComponent() {
      return {
        unclipped: HeaderBannerUnclippedCard,
        image: HeaderBannerImageCard,
        clipped: HeaderBannerClippedCard,
      }[this.banner.variant]
    },
  },
})
</script>

<template>
  <component :is="headerBannerComponent" :banner="banner" />
</template>
